import { render, staticRenderFns } from "./formRender.vue?vue&type=template&id=5b707c7a&scoped=true&"
import script from "./formRender.vue?vue&type=script&lang=js&"
export * from "./formRender.vue?vue&type=script&lang=js&"
import style0 from "./formRender.vue?vue&type=style&index=0&id=5b707c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b707c7a",
  null
  
)

export default component.exports